import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { PortfolioDashboard } from './components/PortfolioDashboard';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<PortfolioDashboard />} />
      </Routes>
    </Router>
  );
}

export default App;

